var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('duration-input',{attrs:{"value":_vm.value,"label":"Arbeitszeit","hide-details":_vm.hideDetails,"disabled":_vm.disabled,"loading":_vm.loading},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }